import * as index from '@syncfusion/ej2-treemap';
index.TreeMap.Inject( index.TreeMapTooltip,index.TreeMapLegend,index.TreeMapHighlight,index.TreeMapSelection);
export * from '@syncfusion/ej2-treemap';
